import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    {
      ref: "mainRef",
      staticClass: "d-flex flex-column gr-4",
      class: _setup.isMobile ? "px-4 gr-10" : "gr-4",
    },
    [
      _setup.selectedTeamMember
        ? [
            _c(
              VBtn,
              {
                staticClass: "align-self-start",
                attrs: { color: "primary", text: "" },
                on: { click: _setup.handleClickBack },
              },
              [
                _c("span", { staticClass: "ui-icon-arrow-back mr-3" }),
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.t("О проекте", _setup.options)) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(_setup.TeamMemberDescriptionCard, {
              attrs: { "team-member": _setup.selectedTeamMember },
            }),
            _vm._v(" "),
            _c(_setup.InfoCard, {
              attrs: {
                title: _setup.t("Достижения", _setup.options),
                "text-html": _setup.transDynamic(
                  _setup.selectedTeamMember,
                  `description,${_setup.language},${_setup.needTranslate}`
                ),
              },
            }),
          ]
        : [
            _vm.isSuperUser && !_setup.isMobile
              ? _c(
                  "a",
                  {
                    staticClass: "adminka d-block pa-2",
                    attrs: {
                      href: _setup.reverseFull({
                        name: "admin:info_inforawhtml_change",
                        args: [_vm.infoId],
                      }),
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v(_vm._s(_setup.t("править", _setup.options)))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.infoRecords, function (infoRecord, index) {
              return _c(index === 0 ? _setup.FirstInfoCard : _setup.InfoCard, {
                key: `info-card-${infoRecord.id}`,
                tag: "InfoCard",
                class: { "mx-n4": _setup.isMobile && index === 0 },
                attrs: {
                  "adminka-url":
                    _vm.isSuperUser && !_setup.isMobile
                      ? _setup.reverseFull({
                          name: "admin:info_inforawhtmlrecord_change",
                          args: [infoRecord.id],
                        })
                      : undefined,
                  title: _setup.transDynamic(
                    infoRecord,
                    `name,${_setup.language},${_setup.needTranslate}`
                  ),
                  "text-html": _setup.transDynamic(
                    infoRecord,
                    `html_code,${_setup.language},${_setup.needTranslate}`
                  ),
                  truncated: "",
                },
              })
            }),
            _vm._v(" "),
            _vm.teamMembers.length
              ? _c(
                  _setup.InfoCard,
                  {
                    ref: "teamMembersRef",
                    attrs: { title: _setup.t("Наша команда", _setup.options) },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-wrap gr-6 gc-4 justify-space-between",
                      },
                      [
                        _vm.isEditorUser && !_setup.isMobile
                          ? _c(
                              "a",
                              {
                                staticClass: "adminka",
                                attrs: {
                                  href: `${_setup.reverseFull({
                                    name: "admin:info_teammember_add",
                                  })}?sites=<${_vm.siteName}>`,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _setup.t(
                                      "Добавить нового члена команды",
                                      _setup.options
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.isMobile
                          ? _vm._l(_vm.teamMembers, function (teamMember) {
                              return _c(_setup.TeamMemberCardMobile, {
                                key: `team-member-${teamMember.id}`,
                                attrs: { "team-member": teamMember },
                              })
                            })
                          : _vm._l(_vm.teamMembers, function (teamMember) {
                              return _c(_setup.TeamMemberCard, {
                                key: `team-member-${teamMember.id}`,
                                attrs: {
                                  "adminka-url":
                                    _vm.isEditorUser && !_setup.isMobile
                                      ? _setup.reverseFull({
                                          name: "admin:info_teammember_change",
                                          args: [teamMember.id],
                                        })
                                      : undefined,
                                  "team-member": teamMember,
                                },
                                on: {
                                  click: function ($event) {
                                    return _setup.handleClickTeamMember(
                                      teamMember
                                    )
                                  },
                                },
                              })
                            }),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }